module.exports = __webpack_public_path__ + "static/media/16.71d16f0d.jpeg";